import { AccountChartsContextProvider } from "Context/AccountCharts";
import { BalancesContextProvider } from "Context/Balances";
import { ClientPaymentsContextProvider } from "Context/ClientPayments";
import { EndCustomerContextProvider } from "Context/EndCustomers";
import { EndCustomerPaymentBundleContextProvider } from "Context/EndCustomerPaymentBundles";
import { InvoicesContextProvider } from "Context/Invoices";
import { PayRuleType, PayRulesContextProvider } from "Context/PayRules";
import { Outlet } from "react-router-dom";
import { ClientContextProvider } from "Context/Client";
import { ClientsContextProvider } from "Context/Clients";
import { ArticlesContextProvider } from "Context/Articles";

export const AccountChartsLayout = () => (
  <AccountChartsContextProvider>
    <Outlet />
  </AccountChartsContextProvider>
);

export const ClientsLayout = () => <Outlet />;

export const ClientPaymentsLayout = () => (
  <ClientPaymentsContextProvider>
    <Outlet />
  </ClientPaymentsContextProvider>
);

export const EndCustomerLayout = () => (
  <EndCustomerContextProvider>
    <Outlet />
  </EndCustomerContextProvider>
);

export const MyPagesEndCustomerLayout = () => (
  <EndCustomerContextProvider>
    <ClientsContextProvider>
      <ArticlesContextProvider>
        <Outlet />
      </ArticlesContextProvider>
    </ClientsContextProvider>
  </EndCustomerContextProvider>
);

export const EndCustomersArticlesLayout = () => (
  <PayRulesContextProvider type={PayRuleType.ENDCUSTOMER}>
    <AccountChartsContextProvider>
      <Outlet />
    </AccountChartsContextProvider>
  </PayRulesContextProvider>
);

export const EndCustomerUnplacedLayout = () => (
  <AccountChartsContextProvider>
    <Outlet />
  </AccountChartsContextProvider>
);

export const ClientsArticlesLayout = () => (
  <PayRulesContextProvider type={PayRuleType.CLIENT}>
    <AccountChartsContextProvider>
      <Outlet />
    </AccountChartsContextProvider>
  </PayRulesContextProvider>
);

export const InvoicesLayout = () => (
  <EndCustomerContextProvider>
    <InvoicesContextProvider>
      <Outlet />
    </InvoicesContextProvider>
  </EndCustomerContextProvider>
);

export const BookingLayout = () => (
  <AccountChartsContextProvider>
    <Outlet />
  </AccountChartsContextProvider>
);

export const ClientAccountLayout = () => <Outlet />;

export const BalancesLayout = () => (
  <BalancesContextProvider>
    <Outlet />
  </BalancesContextProvider>
);

export const EndCustomerPaymentBundlesLayout = () => (
  <EndCustomerPaymentBundleContextProvider>
    <Outlet />
  </EndCustomerPaymentBundleContextProvider>
);
